<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "input-state" | translate }}</mat-label
      ><input
        type="text"
        matInput
        [required]="required"
        [disabled]="disabled"
        [matAutocomplete]="autoComplete"
        formControlName="name"
      />
      <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let state of states"
          (onSelectionChange)="handleStateChange($event, state)"
          [value]="state.name.toUpperCase()"
          class="autocomplete"
        >
          {{ state.name | uppercase }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        translate
        *ngIf="
          searchForm.controls.name.touched &&
          searchForm.controls.name.hasError('required')
        "
        >{{ requiredText || "required-state" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
